import styled from 'styled-components'

export const SalaryListFilterWrapper = styled.div`
  margin-bottom: 15px;
`
